module.exports = __webpack_public_path__ + "static/img/70.ed60908.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/news/gallery/22/70.jpg
// module id = 734
// module chunks = 0